import apiCaller from 'services/Api/ApiCaller';
import { API_URL } from 'settings';
import { errorMessage, RequestError } from '../../MarketExplorer/api';
import {
  BatchRequest,
  CorpusJob,
  CorpusState,
  NewsPage,
  TagOption,
} from './types';

const BASE = '/scenario-builder/admin/corpus';
const request = async <T>(
  path: string,
  method: 'GET' | 'POST',
  data: Record<string, unknown> = {},
  signal?: AbortSignal,
): Promise<T> => {
  const response = await apiCaller({
    path,
    method,
    data,
    signal,
    apiUrl: API_URL,
  });
  if (response.status < 200 || response.status >= 300)
    throw new RequestError(
      errorMessage(response.result) || 'The request could not be completed.',
      response.status,
    );
  return response.result as T;
};
export const fetchCorpus = (signal?: AbortSignal) =>
  request<CorpusState>(BASE, 'GET', {}, signal);
export const setCorpus = (enabled: boolean) =>
  request<CorpusState>(BASE, 'POST', { enabled });
export const fetchCorpusJobs = (signal?: AbortSignal) =>
  request<{ results: CorpusJob[] }>(`${BASE}/jobs`, 'GET', {}, signal);
export const fetchCorpusJob = (id: string, signal?: AbortSignal) =>
  request<CorpusJob>(
    `${BASE}/jobs/${encodeURIComponent(id)}`,
    'GET',
    {},
    signal,
  );
export const startBatch = (data: BatchRequest) =>
  request<CorpusJob>(`${BASE}/jobs`, 'POST', data);
export type NewsSourceFilter = 'ai_curated' | 'original' | 'all';
export const searchNews = (
  data: {
    q: string;
    after_id: number;
    limit: number;
    date_start?: string;
    date_end?: string;
    /** 'ai_curated': clean copies only; 'original': organic wire only. */
    source?: NewsSourceFilter;
    /** Comma-separated tag ids; every one must be on the story. */
    tag_ids?: string;
  },
  signal?: AbortSignal,
) => request<NewsPage>('/news/search', 'GET', data, signal);
export const fetchTagOptions = (q: string, signal?: AbortSignal) =>
  request<{ results: TagOption[] }>('/news/tag_options', 'GET', { q }, signal);
